import qs from 'qs';
import { windowExists } from './tenantUtil';

export default class QueryStringHelper {
  static objectToQuery(object: unknown): string {
    const queryString = qs.stringify(object, { encodeValuesOnly: true });
    return `?${queryString}`;
  }

  static getValueByKey(field: string): string | null {
    return new URLSearchParams(window.location.search).get(field);
  }
}

export function tryParse<Type>(item: string | null | undefined, fallback: Type): Type {
  if (!item) {
    return fallback;
  }
  try {
    return JSON.parse(item);
  } catch {
    return fallback;
  }
}

export function getQueryParams(search?: string | undefined): { [key: string]: unknown } {
  if ((search && search.length === 0) || (!search && (!windowExists() || window.location.search.length === 0))) {
    return {};
  }
  const rawParams = search ? qs.parse(search.substring(1)) : qs.parse(window.location.search.substring(1));
  return Object.assign({}, rawParams, {
    selectedOptions: rawParams.selectedOptions ? tryParse(rawParams.selectedOptions as string, {}) : {},
    qty: rawParams.qty ? tryParse(rawParams.qty as string, '') : '',
    owner: rawParams.owner || rawParams.ownerId || undefined,
  });
}

export function removeQueryParam(url: string | URL, key: string | undefined) {
  const realUrl = new URL(url);
  const params = qs.parse(realUrl.search, { ignoreQueryPrefix: true });
  if (key && params[key]) {
    delete params[key];
  }
  const newParams = qs.stringify(params);
  return `${realUrl.protocol}//${realUrl.hostname}${realUrl.port ? `:${realUrl.port}` : ''}${
    realUrl.pathname
  }?${newParams}`;
}

export function addQueryParam(url: string | URL, key: string, value: string) {
  const realUrl = new URL(url);
  const params = qs.parse(realUrl.search, { ignoreQueryPrefix: true });
  params[key] = value;
  const newParams = qs.stringify(params);
  return `${realUrl.protocol}//${realUrl.hostname}${realUrl.port ? `:${realUrl.port}` : ''}${
    realUrl.pathname
  }?${newParams}`;
}
